import { render, staticRenderFns } from "./DevBreakpointInfo.vue?vue&type=template&id=58c33a69&scoped=true"
import script from "./DevBreakpointInfo.vue?vue&type=script&lang=js"
export * from "./DevBreakpointInfo.vue?vue&type=script&lang=js"
import style0 from "./DevBreakpointInfo.vue?vue&type=style&index=0&id=58c33a69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c33a69",
  null
  
)

export default component.exports